module.exports = __webpack_public_path__ + "static/2-43021f0bce17b9092bf9cc2259305875.jpg";